// extracted by mini-css-extract-plugin
export default {"searchMain":"SearchBar_searchMain__iGyW8"};